var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyBulkBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.995 10.863-3.787 1.891a.595.595 0 0 1-.803-.233.636.636 0 0 1-.072-.29V7.997c0 .42.237.679.86.969l3.802 1.897z",
    fill: "url(#aa159357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 1.167H5.19c-1.575 0-2.856.622-2.856 2.212v4.618c0 .42.237.679.86.969l3.802 1.897 3.781 1.891a.588.588 0 0 0 .818-.238.615.615 0 0 0 .072-.285V3.379c-.015-1.59-1.296-2.212-2.876-2.212z",
    fill: "url(#ba159357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.187 5.613h-4.39a.46.46 0 0 1-.457-.461.46.46 0 0 1 .458-.461h4.389a.46.46 0 0 1 .458.46.46.46 0 0 1-.458.462z",
    fill: "url(#ca159357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a159357",
    x1: 2.333,
    y1: 7.997,
    x2: 2.333,
    y2: 12.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba159357",
    x1: 2.333,
    y1: 1.167,
    x2: 2.333,
    y2: 12.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca159357",
    x1: 4.34,
    y1: 4.691,
    x2: 4.34,
    y2: 5.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBulkBookmark);
export default __webpack_public_path__ + "static/media/iconly-bulk-bookmark.279aa1ff.svg";
export { ForwardRef as ReactComponent };